import { get } from '../api.service';

export interface PensionRecord {
    createdDate: string;
    employeeName: string | null;
    invoiceId: number
    invoiceNumber: number
    pensionAmount: number
    userId: number
}

export interface PensionParams {
    PageNumber: number;
    PageSize: number;
}

export interface PensionResponse {
    statusCode: number;
    message: string;
    response: PensionRecord[];
    totalCount?: number;
    numberOfPages?: number;
}

/**
 * Fetches salary records with pagination.
 * Corresponds to: GET /api/Salary?PageSize=10&PageNumber=1
 * @param params - The request parameters containing PageNumber and PageSize.
 * @returns The API response with salary data.
 */
export const fetchPension = async (params: PensionParams): Promise<PensionResponse> => {
    try {
        const response = await get('/salarynoticev2/pension', {
            PageNumber: params.PageNumber,
            PageSize: params.PageSize,
        });
        return response;
    } catch (error) {
        console.error('Error fetching salaries:', error);
        throw error;
    }
};